import ReactDOM from 'react-dom/client';
import React, { Suspense } from 'react';
import './i18n';
import { Provider } from 'react-redux';
import App from './App';
import { SidebarProvider } from './context/SidebarContext';
import { ThemeProvider } from './context/ThemeContext';
import ThemeSuspense from './components/theme/ThemeSuspense';
import store from './store/store';
import './assets/css/invex.css';
import './assets/css/tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <SidebarProvider>
          <Suspense fallback={<ThemeSuspense />}>
            <App />
          </Suspense>
        </SidebarProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
